export default ({ pageState: { editorBlocks }, data: { blockId, data } }) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        data: JSON.parse(JSON.stringify(data)),
        editor: null,
        isEdited: true,
        updatedAt: null
      }
    },
    editorHeaderStatus: 'saving'
  };
};
